export const MuiButton = (palette) => ({
  defaultProps: {
    disableElevation: true,
  },
  styleOverrides: {
    root: {
      fontFamily: "'Roboto', sans-serif",
      fontWeight: 600,
      lineHeight: '24px',
      borderRadius: '8px',
      textTransform: 'none',
      borderColor: palette.primary.main,
      '&.Mui-disabled': {
        backgroundColor: palette.primary.light,
        borderColor: palette.primary.light,
        color: palette.primary.contrastText,
      },
    },
    outlined: {
      borderColor: palette.primary.main,
      color: palette.primary.main,
    },
    contained: {
      backgroundColor: palette.primary.main,
      color: palette.primary.contrastText,
      '&:hover': {
        background: palette.primary[700],
      },
    },
    sizeLarge: {
      padding: '11px 24px',
      fontWeight: 500,
      lineHeight: '24px',
    },
    sizeSmall: {
      padding: '10px 32px',
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
});
